import IMask from 'imask';
import { ajaxFetch, methodPost, fetchData, handleFormSubmission } from "../shared/formHandling";
import { getElement, getSelector } from "../shared/pageComponents";

function initFitty(className, maxSize, minSize) {
    fitty(className, {
        maxSize: maxSize,
        minSize: minSize,
    });
}

document.addEventListener('DOMContentLoaded', function() {
    
    handleFormSubmission('leadGenForm', 'list_buy_form_submission', 'json');

    const phoneInput = getElement('input_3');
    if(phoneInput){
        IMask(phoneInput, {
            mask: '(000) 000-0000'
        });
    }
    
    const offerBensField = getElement('input_35'); 
    if(offerBensField) {
        offerBensField.addEventListener('change', function() {
            const coverageMonthCol = getElement('coverageMonthCol');
            const coverageMonthField = getElement('input_36');
            const offerBensLabel = getElement('offerBensLabel');
            const offerBensValue = offerBensField.value;
            
            if (offerBensValue === 'Yes') {
                coverageMonthCol.style.display = 'inline-flex';
                coverageMonthField.setAttribute('required', 'required');
                offerBensLabel.style.textAlign = 'left';
                
                const firstMonthOption = coverageMonthField.querySelector('option');
                if (firstMonthOption) {
                    firstMonthOption.setAttribute('selected', 'selected');
                }
            } else {
                coverageMonthCol.style.display = 'none';
                coverageMonthField.removeAttribute('required');
                offerBensLabel.style.textAlign = 'center';
                coverageMonthField.value = '';
            }
        });
    }
});

